import { useDispatch, useSelector } from 'react-redux'
import { PokerGameModel, WSChatMessage } from 'mvppoker-portal-common/api'
import { useCallback } from 'react'
import { RootState } from '../AppStore'
import { addGameChatMessage, updateGameChat, setGameChatRead } from '../reducers/activeGame'

export const useActiveGame = (): PokerGameModel | undefined => {
	return useSelector((root: RootState) => root.activeGame.game)
}

export const useActiveGameId = (): string | undefined => {
	return useSelector((root: RootState) => root.activeGame.game?.id)
}

export const useActiveGameChat = () =>
{
	const dispatch = useDispatch()
	const gameChat = useSelector((root: RootState) => root.activeGame.gameChat)
	const hasUnreadGameChat = useSelector((root: RootState) => root.activeGame.hasUnreadChat)

	const update = useCallback(
		(chat: WSChatMessage[]) => {
			dispatch(updateGameChat(chat))
		},
		[dispatch],
	)
	const addMessage = useCallback(
		(message: WSChatMessage) => {
			dispatch(addGameChatMessage(message))
		},
		[dispatch],
	)
	const setRead = useCallback(
		() => {
			dispatch(setGameChatRead())
		},
		[dispatch],
	)
	return { gameChat, hasUnreadGameChat, setGameChatRead: setRead, updateGameChat: update, addGameChatMessage: addMessage }
}